import {
  IntegrationType,
  SidekickSupportedTms,
} from '@shared/generated/graphql';
import { VERIFICATION_SUPPORTED_INTEGRATION_TYPES } from 'clerk_common/enums';
import { integrationTypeToTms } from './tms';

export const verificationSupportedIntegrationTypes: IntegrationType[] =
  VERIFICATION_SUPPORTED_INTEGRATION_TYPES as unknown as IntegrationType[];

export const verificationSupportedSidekickTmsList: SidekickSupportedTms[] =
  verificationSupportedIntegrationTypes
    .map(integrationTypeToTms)
    .filter((tms): tms is SidekickSupportedTms => tms !== null);

export function isTmsVerificationSupported(tms: SidekickSupportedTms): boolean {
  return verificationSupportedSidekickTmsList.includes(tms);
}
